export default "__VITE_ASSET__CMiWECXI__"